/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { InteractSubType } from "../models/interact-sub-type";
import { Interacts } from "../models/interacts";
import { InteractSubLevels } from "../models/interact-sub-levels";
import { InteractSubTypeLicenses } from "../models/interact-sub-type-licenses";
import { InteractSubTypesRestrictedUsers } from "../models/interact-sub-types-restricted-users";
import { InteractSubTypes } from "../models/interact-sub-types";
import { EditInteractSubscription } from "../models/edit-interact-subscription";
import { InteractSubLevel } from "../models/interact-sub-level";
import { InteractSubPrice } from "../models/interact-sub-price";
import { InteractSubPrices } from "../models/interact-sub-prices";
@Injectable({
  providedIn: "root",
})
class AdminInteractiveSubService extends __BaseService {
  static readonly adminInteractiveSubGetInteractSubTypesPath =
    "/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypes";
  static readonly adminInteractiveSubGetInteractSubTypeInteractivesPath =
    "/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypeInteractives";
  static readonly adminInteractiveSubGetInteractSubLevelsPath =
    "/api/admin/interactive/AdminInteractiveSub/GetInteractSubLevelsAll";
  static readonly adminInteractiveSubGetInteractSubLevels2Path =
    "/api/admin/interactive/AdminInteractiveSub/GetInteractSubLevels";
  static readonly adminInteractiveSubGetInteractSubTypeLicensesPath =
    "/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypeLicenses";
  static readonly adminInteractiveSubGetInteractSubTypesRestrictedUsersPath =
    "/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypesRestrictedUsers";
  static readonly adminInteractiveSubCreateInteractiveSubTypePath =
    "/api/admin/interactive/AdminInteractiveSub/CreateInteractiveSubType";
  static readonly adminInteractiveSubEditInteractiveSubTypePath =
    "/api/admin/interactive/AdminInteractiveSub/EditInteractiveSubType";
  static readonly adminInteractiveSubDeleteInteractiveSubTypePath =
    "/api/admin/interactive/AdminInteractiveSub/DeleteInteractiveSubType";
  static readonly adminInteractiveSubGetSubscriptionLevelsPath =
    "/api/admin/interactive/AdminInteractiveSub/GetSubscriptionLevels";
  static readonly adminInteractiveSubCreateSubscriptionLevelPath =
    "/api/admin/interactive/AdminInteractiveSub/CreateSubscriptionLevel";
  static readonly adminInteractiveSubEditSubscriptionLevelPath =
    "/api/admin/interactive/AdminInteractiveSub/EditSubscriptionLevel";
  static readonly adminInteractiveSubDeleteSubscriptionLevelPath =
    "/api/admin/interactive/AdminInteractiveSub/DeleteSubscriptionLevel";
  static readonly adminInteractiveSubGetSubscriptionPricesPath =
    "/api/admin/interactive/AdminInteractiveSub/GetSubscriptionPrices";
  static readonly adminInteractiveSubCreateSubscriptionPricePath =
    "/api/admin/interactive/AdminInteractiveSub/CreateSubscriptionPrice";
  static readonly adminInteractiveSubEditSubscriptionPricePath =
    "/api/admin/interactive/AdminInteractiveSub/EditSubscriptionPrice";
  static readonly adminInteractiveSubDeleteSubscriptionPricePath =
    "/api/admin/interactive/AdminInteractiveSub/DeleteSubscriptionPrice";
  static readonly adminInteractiveSubAddLicensePath =
    "/api/admin/interactive/AdminInteractiveSub/AddSubscriptionLicense";
  static readonly adminInteractiveSubEditSubscriptionLicensePath =
    "/api/admin/interactive/AdminInteractiveSub/EditSubscriptionLicense";
  static readonly adminInteractiveSubGetLicenseHTMLPath =
    "/api/admin/interactive/AdminInteractiveSub/GetLicenseHTML";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminInteractiveSubGetInteractSubTypesResponse(): __Observable<
    __StrictHttpResponse<Array<InteractSubType>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractSubType>>;
      })
    );
  }
  adminInteractiveSubGetInteractSubTypes(): __Observable<
    Array<InteractSubType>
  > {
    return this.adminInteractiveSubGetInteractSubTypesResponse().pipe(
      __map((_r) => _r.body as Array<InteractSubType>)
    );
  }

  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubTypeInteractivesResponse(
    interactiveSubTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<Interacts>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveSubTypeId != null)
      __params = __params.set(
        "interactiveSubTypeId",
        interactiveSubTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypeInteractives`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Interacts>>;
      })
    );
  }
  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubTypeInteractives(
    interactiveSubTypeId?: number
  ): __Observable<Array<Interacts>> {
    return this.adminInteractiveSubGetInteractSubTypeInteractivesResponse(
      interactiveSubTypeId
    ).pipe(__map((_r) => _r.body as Array<Interacts>));
  }
  adminInteractiveSubGetInteractSubLevelsResponse(): __Observable<
    __StrictHttpResponse<Array<InteractSubLevels>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetInteractSubLevelsAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractSubLevels>>;
      })
    );
  }
  adminInteractiveSubGetInteractSubLevels(): __Observable<
    Array<InteractSubLevels>
  > {
    return this.adminInteractiveSubGetInteractSubLevelsResponse().pipe(
      __map((_r) => _r.body as Array<InteractSubLevels>)
    );
  }

  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubLevels2Response(
    interactiveSubTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<InteractSubLevels>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveSubTypeId != null)
      __params = __params.set(
        "interactiveSubTypeId",
        interactiveSubTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetInteractSubLevels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractSubLevels>>;
      })
    );
  }
  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubLevels2(
    interactiveSubTypeId?: number
  ): __Observable<Array<InteractSubLevels>> {
    return this.adminInteractiveSubGetInteractSubLevels2Response(
      interactiveSubTypeId
    ).pipe(__map((_r) => _r.body as Array<InteractSubLevels>));
  }

  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubTypeLicensesResponse(
    interactiveSubTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<InteractSubTypeLicenses>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveSubTypeId != null)
      __params = __params.set(
        "interactiveSubTypeId",
        interactiveSubTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypeLicenses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractSubTypeLicenses>>;
      })
    );
  }
  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubTypeLicenses(
    interactiveSubTypeId?: number
  ): __Observable<Array<InteractSubTypeLicenses>> {
    return this.adminInteractiveSubGetInteractSubTypeLicensesResponse(
      interactiveSubTypeId
    ).pipe(__map((_r) => _r.body as Array<InteractSubTypeLicenses>));
  }

  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubTypesRestrictedUsersResponse(
    interactiveSubTypeId?: number
  ): __Observable<
    __StrictHttpResponse<Array<InteractSubTypesRestrictedUsers>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveSubTypeId != null)
      __params = __params.set(
        "interactiveSubTypeId",
        interactiveSubTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetInteractSubTypesRestrictedUsers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<
          Array<InteractSubTypesRestrictedUsers>
        >;
      })
    );
  }
  /**
   * @param interactiveSubTypeId undefined
   */
  adminInteractiveSubGetInteractSubTypesRestrictedUsers(
    interactiveSubTypeId?: number
  ): __Observable<Array<InteractSubTypesRestrictedUsers>> {
    return this.adminInteractiveSubGetInteractSubTypesRestrictedUsersResponse(
      interactiveSubTypeId
    ).pipe(__map((_r) => _r.body as Array<InteractSubTypesRestrictedUsers>));
  }

  /**
   * @param edit undefined
   */
  adminInteractiveSubCreateInteractiveSubTypeResponse(
    edit: EditInteractSubscription
  ): __Observable<__StrictHttpResponse<InteractSubTypes>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = edit;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/CreateInteractiveSubType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InteractSubTypes>;
      })
    );
  }
  /**
   * @param edit undefined
   */
  adminInteractiveSubCreateInteractiveSubType(
    edit: EditInteractSubscription
  ): __Observable<InteractSubTypes> {
    return this.adminInteractiveSubCreateInteractiveSubTypeResponse(edit).pipe(
      __map((_r) => _r.body as InteractSubTypes)
    );
  }

  /**
   * @param edit undefined
   */
  adminInteractiveSubEditInteractiveSubTypeResponse(
    edit: EditInteractSubscription
  ): __Observable<__StrictHttpResponse<InteractSubTypes>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = edit;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/EditInteractiveSubType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InteractSubTypes>;
      })
    );
  }
  /**
   * @param edit undefined
   */
  adminInteractiveSubEditInteractiveSubType(
    edit: EditInteractSubscription
  ): __Observable<InteractSubTypes> {
    return this.adminInteractiveSubEditInteractiveSubTypeResponse(edit).pipe(
      __map((_r) => _r.body as InteractSubTypes)
    );
  }

  /**
   * @param subTypeId undefined
   */
  adminInteractiveSubDeleteInteractiveSubTypeResponse(
    subTypeId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subTypeId != null)
      __params = __params.set("subTypeId", subTypeId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/DeleteInteractiveSubType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param subTypeId undefined
   */
  adminInteractiveSubDeleteInteractiveSubType(
    subTypeId?: number
  ): __Observable<Blob> {
    return this.adminInteractiveSubDeleteInteractiveSubTypeResponse(
      subTypeId
    ).pipe(__map((_r) => _r.body as Blob));
  }
  adminInteractiveSubGetSubscriptionLevelsResponse(): __Observable<
    __StrictHttpResponse<Array<InteractSubLevel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetSubscriptionLevels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractSubLevel>>;
      })
    );
  }
  adminInteractiveSubGetSubscriptionLevels(): __Observable<
    Array<InteractSubLevel>
  > {
    return this.adminInteractiveSubGetSubscriptionLevelsResponse().pipe(
      __map((_r) => _r.body as Array<InteractSubLevel>)
    );
  }

  /**
   * @param model undefined
   */
  adminInteractiveSubCreateSubscriptionLevelResponse(
    model: InteractSubLevels
  ): __Observable<__StrictHttpResponse<InteractSubLevels>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/CreateSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InteractSubLevels>;
      })
    );
  }
  /**
   * @param model undefined
   */
  adminInteractiveSubCreateSubscriptionLevel(
    model: InteractSubLevels
  ): __Observable<InteractSubLevels> {
    return this.adminInteractiveSubCreateSubscriptionLevelResponse(model).pipe(
      __map((_r) => _r.body as InteractSubLevels)
    );
  }

  /**
   * @param model undefined
   */
  adminInteractiveSubEditSubscriptionLevelResponse(
    model: InteractSubLevels
  ): __Observable<__StrictHttpResponse<InteractSubLevels>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/EditSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InteractSubLevels>;
      })
    );
  }
  /**
   * @param model undefined
   */
  adminInteractiveSubEditSubscriptionLevel(
    model: InteractSubLevels
  ): __Observable<InteractSubLevels> {
    return this.adminInteractiveSubEditSubscriptionLevelResponse(model).pipe(
      __map((_r) => _r.body as InteractSubLevels)
    );
  }

  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionLevelParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   */
  adminInteractiveSubDeleteSubscriptionLevelResponse(
    params: AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionLevelParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.subLevelId != null)
      __params = __params.set("subLevelId", params.subLevelId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/DeleteSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionLevelParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   */
  adminInteractiveSubDeleteSubscriptionLevel(
    params: AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionLevelParams
  ): __Observable<Blob> {
    return this.adminInteractiveSubDeleteSubscriptionLevelResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  adminInteractiveSubGetSubscriptionPricesResponse(): __Observable<
    __StrictHttpResponse<Array<InteractSubPrice>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetSubscriptionPrices`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractSubPrice>>;
      })
    );
  }
  adminInteractiveSubGetSubscriptionPrices(): __Observable<
    Array<InteractSubPrice>
  > {
    return this.adminInteractiveSubGetSubscriptionPricesResponse().pipe(
      __map((_r) => _r.body as Array<InteractSubPrice>)
    );
  }

  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubCreateSubscriptionPriceParams` containing the following parameters:
   *
   * - `TaxRate`:
   *
   * - `SuppressInvoice`:
   *
   * - `ProposalUpload`:
   *
   * - `Price`:
   *
   * - `PeriodTypeId`:
   *
   * - `InteractSubTypeId`:
   *
   * - `InteractSubLevelId`:
   *
   * - `CustomTerms`:
   *
   * - `ClearProposal`:
   */
  adminInteractiveSubCreateSubscriptionPriceResponse(
    params: AdminInteractiveSubService.AdminInteractiveSubCreateSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<InteractSubPrices>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.TaxRate != null) {
      __formData.append("TaxRate", JSON.stringify(params.TaxRate));
    }
    if (params.SuppressInvoice != null) {
      __formData.append(
        "SuppressInvoice",
        JSON.stringify(params.SuppressInvoice)
      );
    }
    if (params.ProposalUpload != null) {
      __formData.append(
        "ProposalUpload",
        params.ProposalUpload as string | Blob
      );
    }
    if (params.Price != null) {
      __formData.append("Price", JSON.stringify(params.Price));
    }
    if (params.PeriodTypeId != null) {
      __formData.append("PeriodTypeId", JSON.stringify(params.PeriodTypeId));
    }
    if (params.InteractSubTypeId != null) {
      __formData.append(
        "InteractSubTypeId",
        JSON.stringify(params.InteractSubTypeId)
      );
    }
    if (params.InteractSubLevelId != null) {
      __formData.append(
        "InteractSubLevelId",
        JSON.stringify(params.InteractSubLevelId)
      );
    }
    if (params.CustomTerms != null) {
      __formData.append("CustomTerms", params.CustomTerms as string | Blob);
    }
    if (params.ClearProposal != null) {
      __formData.append("ClearProposal", JSON.stringify(params.ClearProposal));
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/CreateSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InteractSubPrices>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubCreateSubscriptionPriceParams` containing the following parameters:
   *
   * - `TaxRate`:
   *
   * - `SuppressInvoice`:
   *
   * - `ProposalUpload`:
   *
   * - `Price`:
   *
   * - `PeriodTypeId`:
   *
   * - `InteractSubTypeId`:
   *
   * - `InteractSubLevelId`:
   *
   * - `CustomTerms`:
   *
   * - `ClearProposal`:
   */
  adminInteractiveSubCreateSubscriptionPrice(
    params: AdminInteractiveSubService.AdminInteractiveSubCreateSubscriptionPriceParams
  ): __Observable<InteractSubPrices> {
    return this.adminInteractiveSubCreateSubscriptionPriceResponse(params).pipe(
      __map((_r) => _r.body as InteractSubPrices)
    );
  }

  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionPriceParams` containing the following parameters:
   *
   * - `TaxRate`:
   *
   * - `SuppressInvoice`:
   *
   * - `ProposalUpload`:
   *
   * - `Price`:
   *
   * - `PeriodTypeId`:
   *
   * - `InteractSubTypeId`:
   *
   * - `InteractSubLevelId`:
   *
   * - `CustomTerms`:
   *
   * - `ClearProposal`:
   */
  adminInteractiveSubEditSubscriptionPriceResponse(
    params: AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<InteractSubPrices>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.TaxRate != null) {
      __formData.append("TaxRate", JSON.stringify(params.TaxRate));
    }
    if (params.SuppressInvoice != null) {
      __formData.append(
        "SuppressInvoice",
        JSON.stringify(params.SuppressInvoice)
      );
    }
    if (params.ProposalUpload != null) {
      __formData.append(
        "ProposalUpload",
        params.ProposalUpload as string | Blob
      );
    }
    if (params.Price != null) {
      __formData.append("Price", JSON.stringify(params.Price));
    }
    if (params.PeriodTypeId != null) {
      __formData.append("PeriodTypeId", JSON.stringify(params.PeriodTypeId));
    }
    if (params.InteractSubTypeId != null) {
      __formData.append(
        "InteractSubTypeId",
        JSON.stringify(params.InteractSubTypeId)
      );
    }
    if (params.InteractSubLevelId != null) {
      __formData.append(
        "InteractSubLevelId",
        JSON.stringify(params.InteractSubLevelId)
      );
    }
    if (params.CustomTerms != null) {
      __formData.append("CustomTerms", params.CustomTerms as string | Blob);
    }
    if (params.ClearProposal != null) {
      __formData.append("ClearProposal", JSON.stringify(params.ClearProposal));
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/EditSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InteractSubPrices>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionPriceParams` containing the following parameters:
   *
   * - `TaxRate`:
   *
   * - `SuppressInvoice`:
   *
   * - `ProposalUpload`:
   *
   * - `Price`:
   *
   * - `PeriodTypeId`:
   *
   * - `InteractSubTypeId`:
   *
   * - `InteractSubLevelId`:
   *
   * - `CustomTerms`:
   *
   * - `ClearProposal`:
   */
  adminInteractiveSubEditSubscriptionPrice(
    params: AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionPriceParams
  ): __Observable<InteractSubPrices> {
    return this.adminInteractiveSubEditSubscriptionPriceResponse(params).pipe(
      __map((_r) => _r.body as InteractSubPrices)
    );
  }

  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionPriceParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   *
   * - `periodId`:
   */
  adminInteractiveSubDeleteSubscriptionPriceResponse(
    params: AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.subLevelId != null)
      __params = __params.set("subLevelId", params.subLevelId.toString());
    if (params.periodId != null)
      __params = __params.set("periodId", params.periodId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/DeleteSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionPriceParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   *
   * - `periodId`:
   */
  adminInteractiveSubDeleteSubscriptionPrice(
    params: AdminInteractiveSubService.AdminInteractiveSubDeleteSubscriptionPriceParams
  ): __Observable<Blob> {
    return this.adminInteractiveSubDeleteSubscriptionPriceResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubAddLicenseParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `revision`:
   *
   * - `licenseHTML`:
   */
  adminInteractiveSubAddLicenseResponse(
    params: AdminInteractiveSubService.AdminInteractiveSubAddLicenseParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.revision != null)
      __params = __params.set("revision", params.revision.toString());
    if (params.licenseHTML != null)
      __params = __params.set("licenseHTML", params.licenseHTML.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/AddSubscriptionLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubAddLicenseParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `revision`:
   *
   * - `licenseHTML`:
   */
  adminInteractiveSubAddLicense(
    params: AdminInteractiveSubService.AdminInteractiveSubAddLicenseParams
  ): __Observable<Blob> {
    return this.adminInteractiveSubAddLicenseResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionLicenseParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `revision`:
   *
   * - `licenseHTML`:
   */
  adminInteractiveSubEditSubscriptionLicenseResponse(
    params: AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionLicenseParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.revision != null)
      __params = __params.set("revision", params.revision.toString());
    if (params.licenseHTML != null)
      __params = __params.set("licenseHTML", params.licenseHTML.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/EditSubscriptionLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionLicenseParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `revision`:
   *
   * - `licenseHTML`:
   */
  adminInteractiveSubEditSubscriptionLicense(
    params: AdminInteractiveSubService.AdminInteractiveSubEditSubscriptionLicenseParams
  ): __Observable<Blob> {
    return this.adminInteractiveSubEditSubscriptionLicenseResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubGetLicenseHTMLParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `revision`:
   */
  adminInteractiveSubGetLicenseHTMLResponse(
    params: AdminInteractiveSubService.AdminInteractiveSubGetLicenseHTMLParams
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.revision != null)
      __params = __params.set("revision", params.revision.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractiveSub/GetLicenseHTML`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveSubService.AdminInteractiveSubGetLicenseHTMLParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `revision`:
   */
  adminInteractiveSubGetLicenseHTML(
    params: AdminInteractiveSubService.AdminInteractiveSubGetLicenseHTMLParams
  ): __Observable<string> {
    return this.adminInteractiveSubGetLicenseHTMLResponse(params).pipe(
      __map((_r) => _r.body as string)
    );
  }
}

module AdminInteractiveSubService {
  /**
   * Parameters for AdminInteractiveSubDeleteSubscriptionLevel
   */
  export interface AdminInteractiveSubDeleteSubscriptionLevelParams {
    subTypeId?: number;
    subLevelId?: number;
  }

  /**
   * Parameters for AdminInteractiveSubCreateSubscriptionPrice
   */
  export interface AdminInteractiveSubCreateSubscriptionPriceParams {
    TaxRate?: null | number;
    SuppressInvoice?: boolean;
    ProposalUpload?: null | Blob;
    Price?: null | number;
    PeriodTypeId?: number;
    InteractSubTypeId?: number;
    InteractSubLevelId?: number;
    CustomTerms?: null | string;
    ClearProposal?: boolean;
  }

  /**
   * Parameters for AdminInteractiveSubEditSubscriptionPrice
   */
  export interface AdminInteractiveSubEditSubscriptionPriceParams {
    TaxRate?: null | number;
    SuppressInvoice?: boolean;
    ProposalUpload?: null | Blob;
    Price?: null | number;
    PeriodTypeId?: number;
    InteractSubTypeId?: number;
    InteractSubLevelId?: number;
    CustomTerms?: null | string;
    ClearProposal?: boolean;
  }

  /**
   * Parameters for AdminInteractiveSubDeleteSubscriptionPrice
   */
  export interface AdminInteractiveSubDeleteSubscriptionPriceParams {
    subTypeId?: number;
    subLevelId?: number;
    periodId?: number;
  }

  /**
   * Parameters for AdminInteractiveSubAddLicense
   */
  export interface AdminInteractiveSubAddLicenseParams {
    subTypeId?: number;
    revision?: number;
    licenseHTML?: null | string;
  }

  /**
   * Parameters for AdminInteractiveSubEditSubscriptionLicense
   */
  export interface AdminInteractiveSubEditSubscriptionLicenseParams {
    subTypeId?: number;
    revision?: number;
    licenseHTML?: null | string;
  }

  /**
   * Parameters for AdminInteractiveSubGetLicenseHTML
   */
  export interface AdminInteractiveSubGetLicenseHTMLParams {
    subTypeId?: number;
    revision?: number;
  }
}

export { AdminInteractiveSubService };
